import SidePanelHeader from "../components/SidePanelHeader"
import SidePanelSensitiveInfo from "../components/SidePanelSensitiveInfo"
import SidePanelAuditTrail from "../components/SidePanelAuditTrail"
import { EntityNames } from "../../../../../enums/EntityNames"
import { useNavigate } from "react-router"
import * as Navigation from "../../../../../modules/Navigation";
import SidePanelInfo from "../components/SidePanelInfo"
import SidePanelLocations from "../components/SidePanelLocations"
import { hasPermission } from "../../../../../modules/auth/Permissions/PermissionModule";
import { PermissionConcerns, PermissionTypes } from "../../../../../modules/auth/Permissions/PermissionStrings";
import { usePermissions } from "../../../../../modules/auth/Permissions/PermissionContext"
import { CasesSchema } from "../../../entityComponents/Schemas/CasesSchema"
import { getStatus } from "../../../../../enums/Domain/StatusLookup"
import ActionBar from "../actions/ActionBar"
import EditAction from "../actions/EditAction"
import { hasVisibleChildren } from "../../../entityComponents/Schema"


export default function SidePanelCases({ data, onViewPage }: any) {
    const navigate = useNavigate()
    const permissionsContext = usePermissions();

    function viewEntity() {
        // Only navigate if there are visible children
        if (hasVisibleChildren(data.entityName, permissionsContext)) {
            Navigation.view.navigate(navigate, data.entityName, data.id, data)
        }
    }

    function viewEntityAndTab(tabName?: string) {
        // Only navigate if there are visible children
        if (hasVisibleChildren(data.entityName, permissionsContext)) {
            var indexOfTab = CasesSchema.children?.findIndex(x => x.entityName == tabName) ?? 0
            Navigation.view.navigate(navigate, data.entityName, data.id, data, indexOfTab)
        }
    }

    function getFoundStatus() {
        if (data?.foundStatus === null || data?.foundStatus === undefined) {
            return '';
        }
        const status = getStatus(data.foundStatus);
        return status?.displayValue;
    }

    return (<>
        {data &&
            <>
                {!onViewPage && <SidePanelHeader descriptor="Case no." value={data.code ?? data.caseNumber} statuses={data.status} onClick={(() => { viewEntity() })} />}
                <ActionBar>
                    {hasPermission(permissionsContext.permissions!, PermissionTypes.write, PermissionConcerns.Manage_Case) && 
                        <EditAction id={data.id} parentEntityId={data.rangePackingBoxId} entityName={data.entityName} parentEntityName={EntityNames.packingBox} />}
                </ActionBar>
                <SidePanelInfo
                    values={[
                        { label: "Status", value: onViewPage ? data.status : undefined },
                        { label: "Prefix", value: data.prefix },
                        { label: "Year", value: data.year },
                        { label: "Account", value: data.accountName },
                        { label: "Type", value: data.materialType },
                        { label: "Found Status", value: getFoundStatus() },
                        { label: "Quantity", value: data.quantity ?? "Unknown" },
                    ]}
                />
                {!onViewPage && <SidePanelLocations descriptor="Current Locations" id={data.id} entityName={data.entityName} />}
                {
                    !onViewPage &&
                    hasPermission(permissionsContext.permissions!, PermissionTypes.read, PermissionConcerns.Inventory_Audit_Trails) &&
                    (<SidePanelAuditTrail entityName={EntityNames.cases} id={data.id} viewFunction={() => viewEntityAndTab(EntityNames.audits)} />)
                }
                {hasPermission(permissionsContext.permissions!, PermissionTypes.read, PermissionConcerns.PII_Notes) ? <SidePanelSensitiveInfo descriptor="Notes" data={data} dataTarget="notes" /> : null}
            </>
        }
    </>)
}